"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersImport = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const button_1 = require("client/components/material/button");
const paper_1 = require("client/components/material/paper");
const select_1 = require("client/components/material/select");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/providers/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const Backup_1 = require("material-ui-icons/Backup");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
require("./providers-import.less");
let ProvidersImport = class ProvidersImport extends react_1.Component {
    constructor() {
        super(...arguments);
        this.cacheRowIndex = -1;
        this.provider = {};
        this.siteId = store_3.usersStore.user.value && store_3.usersStore.user.value.siteId
            ? store_3.usersStore.user.value.siteId.toString()
            : "";
        this.siteSelected = false;
        this.handleChangeSite = (id) => {
            this.siteId = id;
        };
        this.handleClickNext = () => {
            this.siteSelected = true;
        };
        this.handleDrop = async (accepted) => {
            if (accepted.length) {
                await store_1.providersStore.parseImportsHeader(accepted, this.siteId);
                store_1.providersStore.importedFileAndSiteId = {
                    accepted,
                    siteId: this.siteId
                };
                router_1.RouteManager.transitionTo(`/providers/import/select`);
            }
        };
    }
    get availableOptions() {
        return store_2.sitesListStore.sites.value
            ? store_2.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    componentWillMount() {
        // sitesListStore.loadSites();
        store_2.sitesListStore.loadSitesNoRelation();
        this.resetSite();
    }
    componentWillUnmount() {
        store_1.providersStore.reset();
        this.resetSite();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    resetSite() {
        if (store_3.usersStore.user.value && store_3.usersStore.user.value.siteUser) {
            this.siteSelected = true;
        }
        else {
            this.siteSelected = false;
        }
    }
    render() {
        return (React.createElement("div", { className: "providers-submit" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("h2", null, "Import Providers")),
            !store_1.providersStore.submitted &&
                (!store_1.providersStore.submission.value ||
                    store_1.providersStore.submission.value.length === 0) && (React.createElement(paper_1.MaterialPaper, { className: "providers-submit__submission" },
                !this.siteSelected && (React.createElement("form", { className: "providers-submit__site-form" },
                    React.createElement("p", null,
                        React.createElement("strong", null, "Please Select a Pharmacy Before Submission")),
                    React.createElement(select_1.MaterialSelect, { className: "providers-submit__site-select", label: "Clinic", options: this.availableOptions, value: this.siteId || "Choose clinic...", onSelect: this.handleChangeSite, searchable: true }),
                    React.createElement(button_1.MaterialButton, { className: "providers-submit__site-button", primary: true, onClick: this.handleClickNext }, "Next"))),
                React.createElement(ui_1.UiDropzone, { className: "providers-submit__dropzone", onDrop: this.handleDrop, loading: store_1.providersStore.submission.loading },
                    React.createElement(Backup_1.default, { className: "providers-submit__download-icon" }),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Drag & Drop Providers File"),
                        React.createElement("br", null),
                        React.createElement("small", null, "(.csv only)")),
                    React.createElement("div", { className: "providers-submit__dropzone-button" },
                        React.createElement(button_1.MaterialButton, { flat: true, className: "browse-button" }, "Browse to Upload"))))),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.computed
], ProvidersImport.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], ProvidersImport.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], ProvidersImport.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], ProvidersImport.prototype, "siteSelected", void 0);
ProvidersImport = __decorate([
    mobx_react_1.observer
], ProvidersImport);
exports.ProvidersImport = ProvidersImport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-import/providers-import.tsx
// module id = 3840
// module chunks = 0